import { render } from "./index.vue?vue&type=template&id=104eee02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=104eee02&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104eee02"],['__file',"src/vab/components/VabCard/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "104eee02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('104eee02', __exports__)) {
    console.log('reload')
    api.reload('104eee02', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=104eee02&scoped=true", () => {
    console.log('re-render')
    api.rerender('104eee02', render)
  })

}


export default __exports__